import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import firebase from "firebase/app";
import 'firebase/storage';
import HowToRegIcon from '@material-ui/icons/HowToReg';

import IconButton from '@material-ui/core/IconButton';
import React,{useCallback, useContext} from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import ParadaMap from './ParadaMap';
import {Autoplace} from './autoplace';
import {authConfig} from "../auth/config";
import Cardpassageiro from './cardpassageiro';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import DeleteIcon from '@material-ui/icons/Delete';
import PostAddIcon from '@material-ui/icons/PostAdd';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Apigeolocaction from 'ip-geolocation-api-javascript-sdk';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Tooltip } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Cardmap from './agendamap';
import {Geosimples} from './geosimples';
import {Geolista} from './geolista';
import {Directionscontext} from '../componentes/directionscontext';
import {Repetidata} from './repetidata';
import Enviarecadochefia from '../componentes/Enviarecadochefia';




const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    
  },
  upload:{
    marginTop: theme.spacing(2),
  },
  title: {
     display: 'none',
     [theme.breakpoints.up('sm')]: {
       display: 'block',
     },
   },
   menuButton: {
     //marginRight: theme.spacing(2),
     marginTop: theme.spacing(2),
     
   },
   submit: {
     margin: theme.spacing(2, 2, 2),
 
    
 
   },
   container: {
     display: 'flex',
     flexWrap: 'wrap',
   },
   textField: {
    
     marginTop:theme.spacing(2),
     marginBottom: theme.spacing(2),
     
     
   },
   form: {
       width: '100%', // Fix IE 11 issue.
       marginTop: theme.spacing(2),
     },

     formControl:{
       margin: theme.spacing(2,0,2),
     },
     icon: {
       color: theme.palette.text.secondary,
       
     },
}));

const classes = makeStyles((theme) => ({
  
}));



//**************************************************************************************************** */
document.title = 'Frota UFSM'
document.logo=''

var destinom;
var saidam;
var lidam;
var lvoltam;
var listadatas=[];

export const  Agendar = withRouter(({history}) => {
//*************************************************geoip */
 /* var IPGeolocationAPI = Apigeolocaction;
  var ipgeolocationApi = new IPGeolocationAPI("30ac7f46208245b7b989da54289ac266", false); 
  console.log("meu ipssss ", ipgeolocationApi)*/
/*listadatas=[];
destinom='';
saidam='';
lidam='';
lvoltam='';*/

console.log(listadatas);
console.log(listadatas);
console.log(listadatas);

  var {directionida,directionvolta} = useContext(Directionscontext);

  //*************************gera id */
  
  const[temporetorno, setatemporetorno]=React.useState();
  const[localdestinomapa, setalocaldestinomapa]=React.useState(['']);
  const[localsaidamapa, setalocalsaidamapa]=React.useState(['']);
  const[geolocalsaidamapa, setageolocalsaidamapa]=React.useState(['']);
  const[directionsida, setadirectionsida]=React.useState(['']);
  const[listaparadasvolta, setalistaparadasvolta]=React.useState(['']);
  const[listaparadasida, setalistaparadasida]=React.useState(['']);
  const[directionsvolta, setadirectionsvolta]=React.useState('');
  const[kmtotal, setakm]=React.useState('');

  const[stateidsol, setsol]=React.useState('');
  const [statedatasol, setedatasol]=React.useState('');
  React.useEffect(() => {
    listadatas=[];
    const timestamp = Date.now(); // This would be the timestamp you want to format

   var dataini = Intl.DateTimeFormat('pt-BR', {year: 'numeric',month:'2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(timestamp);
      
     const datinha =dataini.toString();
     setedatasol(...statedatasol,datinha);
var iddata = timestamp.toString();
setsol(...stateidsol,iddata);

    /*var db = firebase.firestore();
    docRef = db.collection("departamentos").doc();
    var idsooli= docRef.id.toString();
    setsol(...stateidsol,idsooli);
    console.log("idsolicit " , stateidsol)
    */
  },[1!=1]);


  //************************dataini e data fim */

  
  const[staterepetir,setastrepetir]=React.useState([]);
  //const[repetirmaneger,setarepetirmaneger]=React.useState([]);
function removedata(props){
  //var rpttemp=repetirmaneger;
  console.log("props" , props);
  console.log("props" , listadatas);
  var listatemp=[];
  var indiceremove;
  for (let index = 0; index < listadatas.length; index++) {
    if((listadatas[index].datahorasaida!=props[0].datahorasaida)&&(listadatas[index].datahoraretorno!=props[0].datahoraretorno)){
      listatemp.push({datahoraretorno:listadatas[index].datahoraretorno, datahorasaida:listadatas[index].datahorasaida})
    }else{
      indiceremove = index
    }
    
  }
  listadatas=listatemp;
  
 /* staterepetir.map(item=>(
    rpttemp.push(item)
  ))
  
  var repetirtemp=[];
  for (let id = 0; id < rpttemp.length; id++) {
    if(id!=indiceremove){
      repetirtemp.push(rpttemp[id]);
    
    }
    
  }*/
  //setastrepetir(repetirtemp);


  
  
  console.log("listadatas" , listadatas);
  console.log("listadatas" , listatemp);
}



function setaparalistadatas(props){
  console.log( props);
  console.log("listadatas" , props);
  listadatas.push({datahorasaida:props[0].datahorasaida,datahoraretorno:props[0].datahoraretorno});
}

  function handlerepetir (){
    
    var ind = Date.now();
    var keyn = ind.toString();
    setastrepetir(currentArray => [...currentArray, {func: (<Repetidata setaparalistadatas={setaparalistadatas} removedata={removedata}/>)}])
    console.log("array paradas", keyn);
  
 
 
  }
  

  //******************************************controle add paradas */

  
  const[stateparada, setstateparada]=React.useState([]);
  const[stateparadaida, setstateparadaida]=React.useState([]);

  function onChildparadaChanged (e){
    console.log("vou remover", e.chave);
    console.log("paradas aqui 22 ",stateparadasvolta);
   var array = stateparada; // make a separate copy of the array
   var ind=e.chave;
   console.log("apropskey", e.chave);
  //var array2 = statepassageiro.findIndex(x => x.e === this.state.carro.id);
   //console.log("valor index ", index);*/
     /*array.splice(index, 1);
     setstatepassageiro(currentArray => [...currentArray,array]);*/
    const listp= stateparada.filter(tem => tem.value!==ind);
     const listp2= stateparadasvolta.filter(tem => tem.value!==ind);
     console.log("lista p ", listp);
     console.log("lista para ", listp2)

     setstateparada(stateparada,listp)
     setaparadas(stateparadasvolta.listp2)
     //setstatepassageiro(statepassageiro =>[statepassageiro.splice(item => !index.includes(item))])
     console.log("lista p ", stateparada);
     console.log("lista para ", stateparadasvolta)
  
      
    // });
 
  }


  ////
  function onChildparadaidaChanged (e){
    console.log("vou remover", e.chave);
    console.log("paradas aqui 22 ",stateparadasvolta);
   var array = stateparadaida; // make a separate copy of the array
   var ind=e.chave;
   console.log("apropskey", e.chave);
  //var array2 = statepassageiro.findIndex(x => x.e === this.state.carro.id);
   //console.log("valor index ", index);*/
     /*array.splice(index, 1);
     setstatepassageiro(currentArray => [...currentArray,array]);*/
    const listp= stateparadaida.filter(tem => tem.value!==ind);
     const listp2= stateparadasvolta.filter(tem => tem.value!==ind);
     console.log("lista p ", listp);
     console.log("lista para ", listp2)

     setstateparadaida(stateparadaida,listp)
     setaparadasida(stateparadasida.listp2)
     //setstatepassageiro(statepassageiro =>[statepassageiro.splice(item => !index.includes(item))])
     console.log("lista p ", stateparada);
     console.log("lista para ", stateparadasvolta)
  
      
    // });
 
  }
  ////
  
  
  function handleparada (){
    
    var ind = Date.now();
    var keyn = ind.toString();
    setstateparada(currentArray => [...currentArray, {func: (<ParadaMap value={keyn} stateparada={stateparada} setstateparada={setstateparada} setaparadas = {setaparadas} stateparadas={stateparadasvolta} key={keyn} onChildparadaChanged={onChildparadaChanged}/>), value:keyn}])
    console.log("array paradas", keyn);
  
 
 
  }

  function handleparadaida (){
    
    var ind = Date.now();
    var keyn = ind.toString();
    setstateparadaida(currentArray => [...currentArray, {func: (<ParadaMap value={keyn} stateparada={stateparadaida} setstateparada={setstateparadaida} setaparadas = {setaparadasida} stateparadas={stateparadasida} key={keyn} onChildparadaChanged={onChildparadaidaChanged}/>), value:keyn}])
    console.log("array paradas", keyn);
  
 
 
  }
   //************************controle return paradas */
   const [nparadas, setanparadas]=React.useState()
   

   const[stateparadasvolta,setaparadas]=React.useState([]);
   const[stateparadasida,setaparadasida]=React.useState([]);
   
   React.useEffect(() => { // esse é responsável em pegar as alterações
    console.log('vamos parada',stateparadasvolta);
    
   }, [stateparadasvolta,stateparada]);


  

  

  //*******************************controle passageiros */
  const[statepassageiro, setstatepassageiro]=React.useState([]);
  const[statelistapassageiro, setstatelistapassageiro]=React.useState([]);

  const[npassageiros,setnpassageiros]=React.useState('');


 /*function onChildChanged (e){
   console.log("vou remover", e);
  var array = statepassageiro; // make a separate copy of the array
  var ind=e.chave;
  console.log("apropskey", array.length);
  /*var index = statepassageiro.findIndex(x => x.e === this.state.carro.id);
  console.log("valor index ", index);*/
    /*array.splice(index, 1);
    setstatepassageiro(currentArray => [...currentArray,array]);
    const listp= statepassageiro.filter(tem => tem.value!==ind)

    setstatepassageiro(statepassageiro,listp)
    //setstatepassageiro(statepassageiro =>[statepassageiro.splice(item => !index.includes(item))])
 
     
   // });

 }*/

 

  function handlepassageiro (){
    var keyp = statepassageiro.length;
    var ind = Date.now();
    var keyn = ind.toString();
    console.log('key ', keyn)
    if (keyp>3) {
      alert("Para mais de 4 passageiros, deve-se anexar uma lista de Passageiros.")
    } else {
      
    
    setstatepassageiro(currentArray => [...currentArray, {func: (<Cardpassageiro value={keyn} 
      statelistapassageiro={statelistapassageiro} setstatelistapassageiro={setstatelistapassageiro}
       setstatepassageiro = {setstatepassageiro} statepassageiro={statepassageiro} />), value:keyn}])
    console.log("array passageir", statepassageiro);
    }
 
 
  }
    

  React.useEffect(() => { // esse é responsável em pegar as alterações
    console.log('vamos passageiro ',statelistapassageiro);
    
   }, [statelistapassageiro,statepassageiro]);

  //*****************************controle checked */

  
    
  const [state, setState] = React.useState({
    
    checkedaceito: false,
  });

  

  //*************************************check box termos************************************************************ */
  

  const handleCheck = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    if(event.target.checked){
    handleClickOpendtermos();
    }
  };

   //*******************************************dialog termos***************************************************************** */  

      const handletermos = () => {
        
        handleClosedtermos();
      };

      const handletermosrecusa = () => {
        setState(false);
        handleClosedtermos();
      };

      const [valuedestino, setValuedestino] = React.useState({
        descripition:''
      });
      const [opendtermos, setOpendtermos] = React.useState(false);
     // const [geocodedest, setageodoce] = React.useState(false);
     const [geodestino, setageodestino] = React.useState({lat:'', lng:''});
     const [geosaida, setageosaida] = React.useState({lat:'', lng:''});
     const [geoparadasida, setageoparadasida] = React.useState([{lat:'', lng:''}]);
     const [geoparadasvolta, setageoparadasvolta] = React.useState([{lat:'', lng:''}]);
     

      const handleClickOpendtermos = () => {

        destinom=valuedestino;
        saidam=localsaida;
        lidam=stateparadasida;
        lvoltam=stateparadasvolta;
        var mu = Geolista(setageoparadasida,lidam);
       var ou = Geolista(setageoparadasvolta,lvoltam);
       var tal =  Geosimples(setageodestino,destinom);
       var qlq = Geosimples(setageosaida,saidam);
       
       setTimeout(function () {
        
      }, 5000);

        console.log("putz");
        console.log("putz");
        console.log(tal);
       

      setOpendtermos(true);
      };
    
      const handleClosedtermos = () => {
        setOpendtermos(false);
      };
   
/************************************controle maps */
  const classes = useStyles();
  const [localsaida, setValue] = React.useState({
    descripition:''
  });
  const [inputValue, setInputValue] = React.useState();
  const [options, setOptions] = React.useState([]);
  
 
  const [inputValuedestino, setInputValuedestino] = React.useState();
  const [optionsdestino, setOptionsdestino] = React.useState([]);
  const loaded = React.useRef(false);

  

  //********************************upload */
  
  const[statefile, setfile]=React.useState();
  const[stanexo, setaanexo]=React.useState('');
 async function upload(params,file){
    var input = file;
    var file= input.files[0];
    var nome = input.files[0].name;
    if ((input!=null)&&(file!=undefined)) {
    //setaanexo(input.files[0].name);
    
    
   const storageRef = firebase.storage().ref();
  
    const storageRefChild = storageRef.child('anexosagenda/' + params +'/' + input.files[0].name  );
    storageRefChild.put(file)
   await  firebase.storage().ref().put(file) 

    .then (snapshot => { 
       
        return (nome),
        alert('Anexado com Sucesso'); 
    }).catch(function(error) {
      alert("Erro ao Anexar seu Arquivo ", error.message);
      })
    }else{
      return(nome);
    }
    
    }
//*******************************persistir solicitacao***************************** */
var ut;
const[uid, setauid]=React.useState('');
const[nome, setanome]=React.useState('');
const[siape, setasiape]=React.useState('');
const[telefone, setatelefone]=React.useState('');
const[unidadedepartamento, setaunidadedepartamento]=React.useState('');
const[centroadm, setacentroadm]=React.useState('');
const[unidadetransporte, setaunidadetransporte]=React.useState('');
const[campi, setacampi]=React.useState('');
const[datahorasaida, setadatahorasaida]=React.useState('');
const[datahoraretorno, setadatahoraretorno]=React.useState('');
const[tipouser, setatipouser]=React.useState('');
const[stobjetivo, setaobjetivo]=React.useState('');
const[stnomedespesas, setanomedespesas]=React.useState('');
const[stfonerespdespesas, setafonerespdespesas]=React.useState('');
const[stfila,setafila]=React.useState('');
const[stobs,setaobs]=React.useState('');
var code='';

React.useEffect(() => { // esse é responsável em pegar as alterações
  pegauser()
 });

  async function pegauser() {


    //*** ******/


    
    const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       setauid(user.uid);
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
       await  userref.get().then((doc) => {       
        if (doc.exists) {
         console.log("pegou o user para salvar", doc.data());
        
         setatipouser(doc.data().usertipo);
         ut= doc.data().usertipo;
         setanome(doc.data().nome);
         setasiape(doc.data().siape);
         setaunidadedepartamento(doc.data().codunidadedepartamento);
         setacentroadm(doc.data().codcentroadm);
         setaunidadetransporte(doc.data().codunidadetransporte);
         setacampi(doc.data().campi);
         setatelefone(doc.data().telefone);

          //console.log('porraaaaa' , doc.data().lotacao);

          
          
       }else{
         alert('Não encontramos o seu cadastro')
       }
      
      }).catch(function(error) {
        alert("Erro ao localizar o seu cadastro ", error.message);
        })
        pegaorgao();
  }

  var depsolicitante=[''];
async function pegaorgao(){
  console.log("campi ", campi);
  if ((unidadedepartamento!='')&&(unidadedepartamento!=undefined)) {
    console.log("unidep ", unidadedepartamento);
/////
var db1 = firebase.firestore();
var userref =  db1.collection("departamentos").doc(unidadedepartamento);         
await userref.get().then((doc) => {       
  var tempdepsol;
  if (doc.exists) {
   var tempdepsol=[];
  tempdepsol.push({tipodepsolicitante: 'departamentos',coddepartamento: unidadedepartamento,codcentroadm: doc.data().codcentroadm,
  nomedepsol: doc.data().depnome
  })
  depsolicitante= tempdepsol;
  setafila(unidadedepartamento);
  code = "codunidadedepartamento"
    console.log("unitrans ", tempdepsol);
      }else{
  alert('Não encontramos o departamento que você está vinculado')
}}).catch(function(error) {
 alert("Erro ao localizar o seu cadastro ", error.message);
 })
////

  } else {
    if ((centroadm!='')&&(centroadm!=undefined)) {
      console.log("centroadm ", centroadm);
      var db2 = firebase.firestore();
      var userref =  db2.collection("centroadm").doc(centroadm);         
      await userref.get().then((doc) => {       
        var tempdepsol;
        if (doc.exists) {
         var tempdepsol=[];
        tempdepsol.push({tipodepsolicitante: 'centroadm',codcentroadm:centroadm, 
        codunidadetransporte: doc.data().codunidadetransporte,
        nomedepsol: doc.data().nomecentroadm
        })
        depsolicitante= tempdepsol;
        code = "codcentroadm"
        setafila(centroadm)

          console.log("unitrans000 ", tempdepsol);
            }else{
        alert('Não encontramos o centro que você está vinculado')
      }}).catch(function(error) {
       alert("Erro ao localizar o seu cadastro ", error.message);
       })

    } else {
      if ((unidadetransporte!='')&&(unidadetransporte!=undefined)) {
        
  console.log("unitrans v ", unidadetransporte);
 var db3 = firebase.firestore();
  var userref =  db3.collection("unidadetransporte").doc(unidadetransporte);         
  await userref.get().then((doc) => {       
    var tempdepsol;
    if (doc.exists) {
     var tempdepsol=[];
    tempdepsol.push({tipodepsolicitante: 'unidadetransporte',codunidadetransporte:unidadetransporte, 
    nomedepsol: doc.data().nomeunidadetransporte
    })
      depsolicitante= tempdepsol;
      code = "codunidadetransporte"
      setafila(unidadetransporte)
      console.log("unitrans001 ", depsolicitante);
        }else{
    alert('Não encontramos a unidade que você está vinculado')
  }}).catch(function(error) {
   alert("Erro ao localizar o seu cadastro001 ", error.message);
   })

      }
      
    }
    
  }
  
 
}


async function mandadirecoes(props){

console.log("aquiiiiiiii");
 

if((geoparadasida[0].lat!='')&&(geoparadasvolta[0].lat!='')){

  var unit = firebase.firestore().collection("agenda").doc(props).collection('direcoes').doc();


    
 await unit.set({geodestino:geodestino, geosaida:geosaida, geoparadasida:geoparadasida, geoparadasvolta:geoparadasvolta})
.then(() => {
  
console.log("locsaliza successfully updated!", props);

})
.catch((error) => {
  // The document probably doesn't exist.
  console.error("Error updating document: ", error);
});
}else{
  if((geoparadasida[0].lat!='')&&(geoparadasvolta[0].lat=='')){
    var unit =  firebase.firestore().collection("agenda").doc(props).collection('direcoes').doc();


    
    await unit.set({geodestino:geodestino, geosaida:geosaida, geoparadasida:geoparadasida})
.then(() => {
console.log("locsaliza successfully updated!", props);

})
.catch((error) => {
  // The document probably doesn't exist.
  console.error("Error updating document: ", error);
});

  }else{
    if((geoparadasida[0].lat=='')&&(geoparadasvolta[0].lat!='')){
      var unit = firebase.firestore().collection("agenda").doc(props).collection('direcoes').doc();


    
      await unit.set({geodestino:geodestino, geosaida:geosaida, geoparadasvolta:geoparadasvolta})
    .then(() => {
    console.log("locsaliza successfully updated!", props);
    
    })
    .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
    });
  }else{
    if((geoparadasida[0].lat=='')&&(geoparadasvolta[0].lat=='')){
      var unit = firebase.firestore().collection("agenda").doc(props).collection('direcoes').doc();


    
      await unit.set({geodestino:geodestino, geosaida:geosaida})
    .then(() => {
    console.log("locsaliza successfully updated!", props);
    
    })
    .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
    });
  }
}

}
}
}
 
  async function cadastrando (){
    if((geodestino.lat=='')||(geosaida.lat=='')){
      alert("Houve um erro no retorno da Geolocalição da sua solicitação, por favor tente novamente");
      setState.checkedaceito(false);
    }else{
     
    listadatas.push({datahorasaida:datahorasaida,datahoraretorno:datahoraretorno});
    

    var input = document.getElementById("uploads");
   
    
    var nomeupload;
    var idsolicitante1=uid;
    var nomesolicitante1=nome;
    var siapesolicitente1 = siape;
    var telefonesolicitante1 = telefone;

    
    if((outro!='')&&(outro!=undefined)){
      idsolicitante1=outro.id;
      nomesolicitante1=outro.nome;
     siapesolicitente1 = outro.siape;
     telefonesolicitante1 = outro.telefone;


    }

      for (let index = 0; index < listadatas.length; index++) {
       var nsoltemp= stateidsol+ index.toString();
       nomeupload = '';
            var db = firebase.firestore();
            var docRef = db.collection("agenda").doc();
            var refid = docRef.id;
            
            if ((input!=null)&&(input.files.length>0)&&(input!=undefined)){
              nomeupload = input.files[0].name;
            upload(docRef.id, input);
            }
            mandadirecoes(refid);
          
            docRef.set({ 
              idsolicitante: idsolicitante1, nomesolicitante:nomesolicitante1, siapesolicitente: siapesolicitente1, telefonesolicitante: telefonesolicitante1,
              depsolicitacao: depsolicitante, campisolicitante: campi,dsolicitacao : statedatasol,
              temporetorno:temporetorno,
            nsolicitacao :nsoltemp,
             objetivo : stobjetivo,
             kilometragem: kmtotal,
             tipodeslocamento :tipodeslocamento,
             datahorasaida: firebase.firestore.Timestamp.fromDate(new Date(listadatas[index].datahorasaida)),
             datahoraretorno :firebase.firestore.Timestamp.fromDate(new Date(listadatas[index].datahoraretorno)),
             localsaida: localsaida,
             localdestino: valuedestino,
            npassageiro :npassageiros,
            listapassageiros:statelistapassageiro,
            listaparadasvolta:stateparadasvolta,
            listaparadasida:stateparadasida,
            respdespesas: strespdespesas,
            nomerespdespesas: stnomedespesas,
            fonerespdespesas: stfonerespdespesas,
            fila: stfila,
            anexo:nomeupload,
            observacao:stobs,
            status:'solicitado'
                }).then(function () {
                  
                 
                  var rec = "Nova solicitação nº "+nsoltemp;
                  Enviarecadochefia(code,stfila,rec,nomesolicitante1)
                  alert('Solicitação realizada com Sucesso');
              }).catch(function (error) {
                    var errorMessage = error.message;
                console.log('errrrooo ', errorMessage);
                  alert(errorMessage);
                  })

                }



             


              history.push('/PageInit');
              
       
      //
              }
                };
   
  

  
   //************************************controle tipo viagem******************************************** */
                const[tipodeslocamento, settipodeslocamento]=React.useState('1');

                const handleChangeman=(event)=>{
                  var v = event.target.value;
                  settipodeslocamento(event.target.value);
                  if(v==2){
                    setadivdespesas(false);
                  }else{
                    setadivdespesas(true);
                  }
                }

                const[strespdespesas, setarepdespesas]=React.useState('1');
                const[stdivrespdespesas, setadivdespesas]=React.useState(true);

                const handlerespdespesas=(event)=>{
                  setarepdespesas(event.target.value);
                }

                //************************outro usuer */

                var listacentros=[];
                var listadepartamentos=[];
                const[outro, setaoutro]=React.useState();
                const[escondebotaooutrouser, setaescondebotaooutrouser]=React.useState(true);
                const[listaoutrosuser, setalistaoutrosuser]=React.useState([]);
                
                const[escondeoutrouser, setaescondeoutrouser]=React.useState(true);

                async function handleoutrouser(){

                  pegalista(ut);
                 /* if ((ut==2)||(ut==3)) {
                    console.log("Document data pegouppqpq:", ut);
                    //setcodcentro(doc.data().codcentroadm);
                    pegalista(ut);
                    
                   } else {
                    if ((ut==4)||(ut==5)) {
                       //console.log("Document data pegouppqpqaquiiiii:", dado);
                     //pegacoddepartamentos(centroadm,ut);
                     pegalista(ut);
                     //console.log("Document data listadepssss:", listadepartamentos);
                    // pegalista();
                     }else{
                      if ((ut==6)||(ut==7)) {
                        pegalista(ut);
                       //pegacodcentros(unidadetransporte,ut);
                       // pegalista();
                       }
                      }
                    }
*/
                  
                }

               /* async function pegacodcentros(cod,ut1){
                  console.log("entrou no centros:", cod);
                  var db = firebase.firestore();
                  var query = await db.collection("centroadm").where("codunidadetransporte","==", cod).orderBy("nomecentroadm").get()
                  .then(snapshot => {
                    if (snapshot.empty) {
                       // alert('No matching documents.');
                        pegalista(ut1);
                    }
                     
                    snapshot.forEach(doc => {
                        
                      listacentros.push({id: doc.id, nomecentroadm: doc.data().nomecentroadm
                      });
                      console.log("pegou centros ", listacentros );
                })
              })
                  
                  
                  
                .catch(error => {
                    console.log('Não encontramos veículos cadastrados', error);
                });
                console.log("pegou lista centros ", listacentros );
                listacentros.map(item=>{
                 
               pegacoddepartamentos(item.id, ut1);
                })
              }
              
              async function pegacoddepartamentos(cod, ut2){
                console.log("entrou pegar departamentos:", cod);
                
                var db = firebase.firestore();
              var departamentoRef = db.collection("departamentos").where('codcentroadm','==', cod).orderBy("depnome").get()
                  .then(snapshot => {
                      if (snapshot.empty) {
                         // alert('No matching documents.');
                         pegalista(ut2);
                      }
                       
                      snapshot.forEach(doc => {
                          
                        listadepartamentos.push({id: doc.id, depnome: doc.data().depnome});
                      });
                      pegalista(ut2);
                      console.log('imprimindo lista deps', listadepartamentos);
                  })
                  .catch(error => {
                      console.log('Error getting documents', error);
                  })
                }
*/

                async function pegalista(ut3){
                  if((ut3==2)||(ut3==3)) {
      
                    var db = firebase.firestore();
              
                    var query = await db.collection("usuarios").where("usertipo","in", ["1", "2","3"]).where("codunidadedepartamento","==", unidadedepartamento).orderBy("nome").get()
                    .then(function(querySnapshot) {


                      //**************
                      var listausers=listaoutrosuser;
                           querySnapshot.forEach(function(doc) {
                            
                               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                               usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte});
                             console.log("veiculos pqp ", state );
                             
                  
                           });
                           setalistaoutrosuser (listausers);
                      
                      //*************** */
                    
                   })
                  .catch(error => {
                      console.log('Não encontramos veículos cadastrados', error);
                  });
                  
                  }else {
                        if((ut3==4)||(ut3==5)) {
                          var db = firebase.firestore();
                        
                    var query = await db.collection("usuarios").where("usertipo", "in",["1","2","3","4","5"]).where("codcentroadm","==", centroadm).orderBy("nome").get()
                    .then(function(querySnapshot) {
                      var listausers=listaoutrosuser;
                     querySnapshot.forEach(function(doc) {
                     
                      console.log("vdentro query  ", listausers );
                        listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email, 
                          siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                        usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
                      console.log("veiculos pqp ", listausers );
                     
              
                 
                          });
                          setalistaoutrosuser (listausers);
                     
                          console.log("veiculos state poxa ", state );
                        })
                       .catch(error => {
                           console.log('Não encontramos veículos cadastrados', error);
                       });
                       
                       
                        var db = firebase.firestore();
                         var query = db.collection("usuarios").where("vinculocodcentroadm","==", centroadm).get()
                         .then(function(querySnapshot) {
                          var listausers=listaoutrosuser;
                          querySnapshot.forEach(function(doc) {
                            
                              listausers.push({id: doc.id, nome: doc.data().nome, email:doc.data().email,
                                siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                                usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
                            console.log("veiculos pqp ", state );
                           
                 
                          });
                          setalistaoutrosuser (listausers);
                           
                         
                        })
                       .catch(error => {
                           console.log('Não encontramos veículos cadastrados', error);
                       });
                       
                       
                       }else {
                        console.log("valor ut dentro deo egalista", ut);
                        console.log("valor utipo3 dentro deo egalista", ut3);
                        if((ut3==6)||(ut3==7)) {
                          console.log("user tipo poxa", unidadetransporte);
                          var db = firebase.firestore();
                          
              
                          var query = db.collection("usuarios").where("usertipo", "in", ['1','6','7']).where("codunidadetransporte","==", unidadetransporte).get()
                          .then(function(querySnapshot) {
                            var listausers=listaoutrosuser;
                           querySnapshot.forEach(function(doc) {
                            
                               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                               usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte});
                             console.log("veiculos pqp ", state );
                             
                  
                           });
                           setalistaoutrosuser (listausers);
                            
                          
                         })
                        .catch(error => {
                            console.log('Não encontramos veículos cadastrados', error);
                        });
              
                       
                         var db = firebase.firestore();
                          var query = db.collection("usuarios").where("vinculocodunidadetransporte","==", unidadetransporte).orderBy("nome").get()
                          .then(function(querySnapshot) {
                            var listausers=listaoutrosuser;
                           querySnapshot.forEach(function(doc) {
                             
                               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                               usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
                             console.log("veiculos pqp ", state );
                             
                  
                           });
                           setalistaoutrosuser (listausers);
                            
                          
                         })
                        .catch(error => {
                            console.log('Não encontramos veículos cadastrados', error);
                        });
                        
                        
                        }
                       }}

                       setaescondeoutrouser(false)
                }

                const handlesetaoutro=(event, value)=>{
                  console.log(value);
                  console.log(value);
                  console.log(value);
                  setaoutro(value);
                 
                }



return(
 
<Container >

<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Solicitação de Transporte
          </Typography>
      <div id="corpo"   maxWidth="xs" align={"left"} className={classes.paper} >

      

        <Container maxWidth="xs">
           <div id="corpoveiculo" className={classes.paper}>

             
          
        <Typography component="h4" variant="h5" id="datasolicitacao">
        {statedatasol}
        </Typography>

        <Button
        id="outrouser"
        variant="contained"
        color="secondary"
        startIcon={<HowToRegIcon />}
        onClick={handleoutrouser}
        className={classes.menuButton}
      >
        Solicitar para outro Usuário
      </Button>
      <br></br>
      
      <div hidden={escondeoutrouser}>

      <Autocomplete onChange={handlesetaoutro}
                   
                   id="combounidadetchef"
                   options={listaoutrosuser}
                   getOptionLabel={(option) => option.nome}
                   renderInput={(params) => <TextField {...params}  label="Usuário" variant="outlined" />}
              />
        </div>
      


           <form className={classes.form} onSubmit={cadastrando} noValidate={false}>
        
         
        <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="nome"
            fullWidth
            id="numerosolicitacao"
            label="Nº Solicitação"
            value={stateidsol}
            name="numerosolicitacao"
            disabled={true}
            
          />
 

      <TextField
      fullWidth
      required
      onChange={ e=>setadatahorasaida(e.target.value)}
      variant="outlined"
        id="datetimeini"
        label="Data e hora da Saída"
        type="datetime-local"
        value={datahorasaida}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
      fullWidth
      required
      variant="outlined"
        id="datetimefim"
        label="Data e hora do Retorno (saída do local)"
        type="datetime-local"
        onChange={ e=>setadatahoraretorno(e.target.value)}
        value={datahoraretorno}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
{staterepetir.map(item=>(
  //setarepetirmaneger(currentArray => [...currentArray,item ]),

<Grid item key={item.id } >
{item.func}
</Grid>
//console.log('tamanho da lista11111=> ', item)

 
  
  

))}
      


      <Button
        variant="contained"
        color="secondary"
        startIcon={<AddLocationIcon />}
        onClick={handlerepetir}
        className={classes.menuButton}
      >
        Repetir Deslocamento
      </Button>

      <br></br>
   
   
   <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
          required
          onChange={ e=>setaobjetivo(e.target.value)}
          type=""
          fullWidth
          id="objetivo"
          label="Objetivo do Deslocamento"
          name="objetivo"  
          value={stobjetivo}    
          multiline
          rows={4}
          />
<div align={"left"}>
<FormControl component="fieldset">
      
      <RadioGroup aria-label="gender" name="gender1" value={tipodeslocamento} onChange={handleChangeman}>
        <FormControlLabel value="1" control={<Radio />} label="Deslocamento Interno" />
         <FormControlLabel value="2" control={<Radio />} label="Viagem" />
        </RadioGroup>
    </FormControl>
    </div>
           
              <div id="respdespesas" hidden={stdivrespdespesas} align={"left"}>

              <FormControl component="fieldset">
              <FormLabel component="legend">Responsável pelas Despesas</FormLabel>
      <RadioGroup aria-label="gender" name="gender1" value={strespdespesas} onChange={handlerespdespesas}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="Unidade" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="Núcleo Administrativo" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>
              <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
          onChange={ e=>setanomedespesas(e.target.value)}
          required={!stdivrespdespesas}
          type=""
          fullWidth
          value={stnomedespesas}
          id="nomedespesas"
          label="Responsável pelas Despesas"
          name="nomedespesas"      
          
          />
           <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
          onChange={ e=>setafonerespdespesas(e.target.value)}
          required={!stdivrespdespesas}
          type=""
          fullWidth
          id="fonerespdespesas"
          label="Telefone do Responsável pelas Despesas"
          name="fonerespdespesas"      
          />
                
                
                </div>    

    
      
              
                   
           

             
<Autoplace label={"Local de Saída"} setValue={setValue}/>

      
{stateparadaida.map(item=>(
  item.func

))}


<Button
        variant="contained"
        color="secondary"
        startIcon={<AddLocationIcon />}
        onClick={handleparadaida}
        className={classes.menuButton}
      >
        Adicionar Parada na Ida
      </Button>

      <br></br>

      
    



    <Autoplace label={"Local de Destino"} setValue={setValuedestino}/>



{stateparada.map(item=>(
  item.func

))}


<Button
        variant="contained"
        color="secondary"
        startIcon={<AddLocationIcon />}
        onClick={handleparada}
        className={classes.menuButton}
      >
        Adicionar Parada no Retorno
      </Button>

      <br></br>
      
      <TextField
            variant="outlined"
            margin="normal"
            onChange={ e=>setnpassageiros(e.target.value)}
            required
            type="Number"
            fullWidth
            id="npassageiros"
            label="Nº de Passageiros"
            name="npassageiros"
            value={npassageiros}
            />
             <Typography component="h7" variant="h10" className={classes.upload}>
         Até 4 passageiros, adicione pelo botão, para mais do que 4 passageiros deve-se anexar uma lista de passageiros. 
        </Typography>
           
            

{statepassageiro.map(item=>(
  item.func
  //<Cardpassageiro value={item}  onChildChanged={onChildChanged}/>
  
  

))}
          
<br></br>
<Button
        variant="contained"
        color="secondary"
        startIcon={<PersonAddIcon />}
        onClick={handlepassageiro}
        className={classes.menuButton}
      >
         Adicionar Passageiro
      </Button>
      <br></br>
      <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setaobs(e.target.value)}
          type=""
          fullWidth
          id="observacao"
          label="Observações"
          name="observacao"  
          value={stobs}    
          multiline
          rows={4}
          />


           
      <div align={"left"}>
      <Typography  className={classes.upload} >
         Anexar Arquivo 
        </Typography>
         
    <input startIcon={<PostAddIcon />}  onChange={e=>setfile(e.target.value)} type="file" id="uploads" name="uploads" accept=".jpg, .jpeg, .png, .pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
  
 </input>
 </div>
 
       
 <br></br>
         
 


        <FormGroup>
        <FormControlLabel
        control={
          <Checkbox
          required
            checked={state.checkedaceito}
            onChange={handleCheck}
            name="checkedaceito"
            color="primary"
          />
        }
       
        label ="Aceito os Termos de uso "
        
        
      />

</FormGroup>


<Dialog open={opendtermos} variant="outlined" onClose={handletermosrecusa} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-termos">TERMO DE COMPROMISSO </DialogTitle>
        <DialogContent>
          <DialogContentText>

           <br></br>
          ** leia até o final
          <br></br>


          <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="respviagem"
            label="Responsável pela Solicitação"
            name="orgão"
            disabled={true}
            
            value={nome}
           // value={directionida.geocoded_waypoints[0].place_id}
            
            />

          <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="siape"
            label="SIAPE"
            name="siape"
            disabled={true}
            value={siape}
            />



<TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="destino"
            label="Destino da Viagem e Local de Saída do Retorno"
            name="destino"
            disabled={true}
            value={valuedestino==null ? '':valuedestino.description}
            />

<TextField
      fullWidth
      required
      variant="outlined"
        id="datetimeini2"
        label="Data e hora da Saída"
        type="datetime-local"
        disabled={true}
        value={datahorasaida}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
          
        }}
      />

<TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="localsaida"
            label="Local da Saída"
            name="localsaida"
            disabled={true}
            value ={localsaida===null ? '':localsaida.description}
            //value={localsaida.description}
            />

<TextField
      fullWidth
      required
      variant="outlined"
        id="datetimefim2"
        label="Data e hora do Retorno"
        type="datetime-local"
        disabled={true}
        value={datahoraretorno}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
          
        }}
      />



<TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="npassageiros"
            label="Número de Passageiros:"
            name="nPassageiros"
            disabled={true}
            value={npassageiros}
            />
           
           
            <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type=""
            fullWidth
            id="km"
            label="Quilometragem Total prevista"
            name="km"
            disabled={true}
            value={kmtotal}
            />
            <div id="mapa">
          <Cardmap   localdestino={geodestino} localsaida={geosaida} setakm={setakm} setatemporetorno={setatemporetorno}
          listaparadasida={geoparadasida} listaparadasvolta={geoparadasvolta}          />

</div>
<br></br>

NORMAS GERAIS<br></br>
1 - Os danos ou anormalidades que porventura vierem a acontecer, causados pelos passageiros da “Viagem”, bem como os recursos para custeio das despesas (Art. 19/Resolução Nº 18/90) serão de inteira responsabilidade do Órgão solicitante e/ou do responsável pela viagem. <br></br>
2 - Quando o veículo não estiver rodando em viagem, não é permitida a utilização do mesmo para pernoites de passageiros.<br></br>
3 - É expressamente proibido o transporte e consumo de bebidas alcoólicas no interior do veículo.<br></br>
4 - É expressamente proibido o transporte de pessoas cujos nomes não constem da relação de passageiros, bem como de pessoas não pertencentes ao Quadro da Instituição; ressalvados os casos de comprovação de vínculo com a Instituição, mediante documento enviado a este Núcleo.<br></br>
5 - Somente será permitida a lotação de bancos; não podendo em hipótese alguma passageiros viajarem em pé.<br></br>
6 - O itinerário da viagem deverá ser rigorosamente cumprido, salvo motivo de força maior, a ser justificado posteriormente.<br></br>
7 - Mesmo já autorizada, a viagem poderá ser cancelada se no momento de embarque o número de passageiros for considerado insuficiente pelo motorista e/ou responsável pela viagem.<br></br>
8 - Será cancelada a viagem, mesmo já autorizada, se no momento do embarque não se fizer presente o responsável pela viagem, bem como sua participação em todo o percurso do itinerário.<br></br>
9 - Nas saídas dos deslocamentos agendados: o tempo de espera do motorista pelo(s) passageiro(s) terá tolerância máxima de 15 minutos (exceto em casos isolados, com justificativa pertinente e aviso prévio). Decorrido este tempo, o motorista poderá retornar com o veículo para a garagem, considerando o deslocamento como cancelado sem aviso prévio.<br></br>
10 - Para deslocamentos com saída de Santa Maria entre 08h e 17h (horário de expediente), fica definido como local de embarque apenas o Campus Sede (Camobi). Esta determinação também é válida para o desembarque, nos deslocamentos que tenham a previsão de chegada compreendida neste horário.<br></br>
11 – Respeitando a Convenção Coletiva de Trabalho da categoria dos motoristas, o Núcleo de Transporte organizará as escalas de trabalho com a finalidade de atender as viagens sem infringir a legislação trabalhista, reservando-se o direito de recusar agendamento de viagens cuja duração extrapole os limites estabelecidos.<br></br>

<br></br> ***Sua Assinatura eletrônica será coletada usando seu dados de conexão (IP, Provedor, Localização ).<br></br>	
    <br></br>Ciente e de acordo.<br></br>
   
    <Button  variant="contained" onClick={handletermos} color="primary" className={classes.submit}>
            Ciente
          </Button>
    
            </DialogContentText>
              
          
      </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handletermosrecusa} color="primary" className={classes.submit}>
            Cancelar
          </Button>
         
        </DialogActions>
      </Dialog>
      
      

      <Typography component="h7" variant="h10" className={classes.upload}>
         * Preenchimento obrigatório 
        </Typography>
      
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.menuButton}
            //onClick = {cadastrando}        
              >
            Solicitar
          </Button>
                    
        </form>




           </div>
           </Container>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Agendar;
